(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tab-icon-section"] && !Shopify.designMode) return;
  try {
    
    document.querySelectorAll('.itg_tab_icon_img').forEach(icon => {
        icon.addEventListener('click', function () {
            const mainIndex = this.getAttribute('data-main-index');
            document.querySelectorAll('.itg_tab_icon_img').forEach(i => {
            i.classList.remove('active');
            });
            this.classList.add('active');
            document.querySelectorAll('.itg_tab_icon_content .itg_tab_icon_part').forEach(part => {
            part.classList.remove('active');
            if (part.getAttribute('data-tab-index') === mainIndex) {
                part.classList.add('active');
            }
            });
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vivana-article"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.vivana-article').forEach(function (root) {
    /* Auto-build the table of contents from prose h2 headings. */
    var toc = root.querySelector('[data-va-toc]');
    var prose = root.querySelector('[data-va-prose]');
    if (toc && prose) {
      var list = toc.querySelector('[data-va-toc-list]');
      /* Skip h2s flagged with [data-no-toc] — used by conditional blocks
         (e.g. the "Researchers examining" section) that have their own
         heading but shouldn't appear in the auto-generated TOC. */
      var headings = prose.querySelectorAll('h2:not([data-no-toc])');
      var entries = [];
      headings.forEach(function (h, i) {
        if (!h.id) { h.id = 'va-h-' + (i + 1); }
        var num = (i + 1 < 10 ? '0' : '') + (i + 1);
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + h.id;
        /* Two spans per row matching the reference markup:
           - num:  serif italic `01/02/…` styled number
           - text: the heading text
           The small `1.` simple counter on the left is generated by a
           CSS counter (`a::before` in vivana-article.css), so the JS
           stays markup-minimal. */
        a.innerHTML =
          '<span class="vivana-article__toc-num">' + num + '</span>' +
          '<span class="vivana-article__toc-text">' + h.textContent.trim() + '</span>';
        li.appendChild(a);
        list.appendChild(li);
        entries.push({ id: h.id, link: a });
      });

      if (entries.length) {
        toc.removeAttribute('hidden');
        var bodyGrid = root.querySelector('.vivana-article__body-grid');
        if (bodyGrid) { bodyGrid.classList.add('has-toc'); }
        /* Highlight the heading currently in view. */
        if ('IntersectionObserver' in window) {
          var obs = new IntersectionObserver(function (items) {
            items.forEach(function (item) {
              if (item.isIntersecting) {
                entries.forEach(function (e) { e.link.classList.remove('is-active'); });
                var match = entries.filter(function (e) { return e.id === item.target.id; })[0];
                if (match) { match.link.classList.add('is-active'); }
              }
            });
          }, { rootMargin: '-20% 0px -70% 0px' });
          headings.forEach(function (h) { obs.observe(h); });
        }
      }
    }

    /* Reveal + relocate the "Researchers examining" block ONLY when its
       metafield heading matches a body H2 or H3. The heading comes from
       article.metafields.custom.researchers_examining_heading (exposed via
       data-va-match-heading; falls back to "What researchers are examining").
       Liquid renders the block hidden at the end of article.content; this JS
       finds the H2/H3 whose text matches the heading, moves the block in right
       after it, and reveals it. If no heading matches, the block stays hidden —
       so the content shows only when the headings line up. */
    var researchersSection = root.querySelector('[data-va-researchers]');
    if (researchersSection && prose) {
      var wantHeading = (researchersSection.getAttribute('data-va-match-heading') || '')
        .replace(/\s+/g, ' ').trim().toLowerCase();
      if (wantHeading) {
        var headingEls = prose.querySelectorAll('h2, h3');
        for (var i = 0; i < headingEls.length; i++) {
          var headingText = (headingEls[i].textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
          if (headingText === wantHeading || headingText.indexOf(wantHeading) !== -1) {
            headingEls[i].insertAdjacentElement('afterend', researchersSection);
            researchersSection.style.display = '';
            break;
          }
        }
      }
    }

    /* Relocate the "Extract matters" stats card so it sits just before the
       NEXT H2 after the "Why the extract matters" H2 — i.e. after that
       section's intro paragraph, before the following section. Liquid
       renders it hidden at the end of the prose as a fallback; this moves
       it into place and reveals it. No-op if the matching H2 isn't found. */
    var extractBlock = root.querySelector('#extract-matters-block');
    if (extractBlock && prose) {
      var emMatch = /why the extract matters/i;
      var emH2s = prose.querySelectorAll('h2');
      var targetH2 = null;
      for (var k = 0; k < emH2s.length; k++) {
        if (emMatch.test(emH2s[k].textContent || '')) { targetH2 = emH2s[k]; break; }
      }
      if (targetH2) {
        /* Walk forward through siblings to find the next H2. */
        var nextH2 = null;
        var node = targetH2.nextElementSibling;
        while (node) {
          if (node.tagName === 'H2') { nextH2 = node; break; }
          node = node.nextElementSibling;
        }
        extractBlock.style.display = 'block';
        if (nextH2) {
          nextH2.parentNode.insertBefore(extractBlock, nextH2);
        } else {
          /* No following H2 — drop it in right after the matching H2's block. */
          targetH2.parentNode.appendChild(extractBlock);
        }
      }
    }

    /* Copy-link share button. */
    var copyBtn = root.querySelector('[data-va-copy]');
    if (copyBtn && navigator.clipboard) {
      var copyTimer;
      copyBtn.addEventListener('click', function () {
        navigator.clipboard.writeText(window.location.href).then(function () {
          copyBtn.classList.add('is-copied');
          clearTimeout(copyTimer);
          copyTimer = setTimeout(function () { copyBtn.classList.remove('is-copied'); }, 1800);
        });
      });
    }

    /* Feedback buttons — visual selection only (no backend). */
    var votes = root.querySelectorAll('[data-va-vote]');
    votes.forEach(function (btn) {
      btn.addEventListener('click', function () {
        votes.forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vivana-journal-blog"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.vivana-journal').forEach(function (section) {
    var btn = section.querySelector('[data-vj-load-more]');
    var grid = section.querySelector('[data-vj-grid]');
    if (!btn || !grid) return;

    var batch = parseInt(btn.getAttribute('data-batch'), 10) || 6;

    btn.addEventListener('click', function () {
      // Reveal the next `batch` cards that are still hidden.
      var hidden = grid.querySelectorAll('[data-vj-card][hidden]');
      for (var i = 0; i < batch && i < hidden.length; i++) {
        hidden[i].removeAttribute('hidden');
      }
      // Nothing left hidden → hide the button.
      if (!grid.querySelector('[data-vj-card][hidden]')) {
        btn.setAttribute('hidden', '');
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
